import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

import { useFormik } from "formik"
import { ToastContainer } from "react-toastify"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Form,
  FormFeedback,
  Input,
  Row,
} from "reactstrap"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
import * as Yup from "yup"
import { toolbarOptions } from "pages/Ecommerce/EcommerceOrders/CMSDetails"
import ReactQuill from "react-quill"

function EditQAndA() {
  const [questionAndAnswerDetails, setQuestionAndAnswerDetails] = useState({})
  const [open, setOpen] = useState([])
  const [segmentList, setSegmentList] = useState([])
  const [adding, setAdding] = useState(false)

  const { id } = useParams()
  const navigate = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      question: "",
      isActive: "true",
      webhookIdentifier: "",
      description: "",
      shortForm: "",
      question_type: null,
      image: null,
      segmentId: null,
      boilerPlateText: "",
    },
    validationSchema: Yup.object({
      // WE can use this later for validation if needed
      question: Yup.string().required("Please Enter Your Question"),
      isActive: Yup.string().required("Please Select Status"),
      webhookIdentifier: Yup.string().required(
        "Please Enter WebhookIdentifier"
      ),
      description: Yup.string().nullable(),
      shortForm: Yup.string().required("Please Enter Short Form"),
      question_type: Yup.string()
        .required("Please Select Type")
        .test("question_type", "Please Select Type", value => {
          return value !== "null"
        }),
      // image: Yup.string().required("Please Select Image"),
      segmentId: Yup.string()
        .required("Please Select Segment")
        .test("segmentId", "Please Select Segment", value => {
          return value !== "null"
        }),
        boilerPlateText: Yup.string().test({
          name: "boilerPlateText",
          test: (value, context) => {
            if (
              context.parent.question_type === "SHORT_ANSWER" ||
              context.parent.question_type === "MULTI_CORRECT"
            ) {
              return true
            } else {
              if(!Boolean(value) || value === "<p><br></p>"){
              return context.createError({
                message: "Please Enter Boiler Plate Text",
              })
            }
              else{
                return true
            }
            }
          },
        }),
    }),
    onSubmit: values => {
      const formData = new FormData()
      formData.append("question", values.question)
      formData.append("isActive", values.isActive === "true")
      formData.append("webhookIdentifier", values.webhookIdentifier)
      formData.append("description", values.description)
      formData.append("shortForm", values.shortForm)
      formData.append("question_type", values.question_type)
      formData.append("segmentId", values.segmentId)
      formData.append("boilerPlateText", values.boilerPlateText)
      values.image && formData.append("image", values.image)
      updateQuestion(formData)
    },
  })

  const updateQuestion = async formData => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.updateQuestion(id, formData)
      notification("success", "Question Updated Successfully")
      setQuestionAndAnswerDetails(data)
      setAdding(false)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  const getQuestionAndAnswerById = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchQuestionAndAnswerById(id)
      setQuestionAndAnswerDetails(data)
      validation.setValues({
        question: data.question,
        isActive: data.isActive.toString(),
        webhookIdentifier: data.webhookIdentifier,
        description: data.description,
        shortForm: data.shortForm,
        question_type: data.question_type,
        image: data.image,
        segmentId: data.segment.id,
        boilerPlateText: data.boilerPlateText,
      })
      validation.setFieldValue("isActive", data.isActive.toString())
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  const getSegmentList = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchSegmentList()
      setSegmentList(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  useEffect(() => {
    getSegmentList()
    getQuestionAndAnswerById()
  }, [])

  console.log(validation.errors)

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs={12}>
              <div className=" h-100 d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-16 text-uppercase">
                  Manage Question
                </h4>
              </div>
            </Col>
          </Row>
          <Form
            className="form-horizontal"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row className="mt-3">
              <Col xs="12">
                <Card>
                  <CardBody>
                    <Row>
                      <Col xs={12}>
                        <span
                          style={{
                            position: "absolute",
                            left: "0rem",
                            padding: "0.5rem .8rem",
                            borderTopRightRadius: "0.5rem",
                            borderBottomRightRadius: "0.5rem",
                            backgroundColor: "#e4661d",
                            color: "#fff",
                          }}
                        >
                          Q{questionAndAnswerDetails?.id}
                        </span>
                      </Col>
                    </Row>

                    <Row
                      style={{
                        rowGap: "1.5rem",
                      }}
                      className="mt-5"
                    >
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Question Text
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="9">
                        <Input
                          name="question"
                          placeholder="Enter question"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.question || ""}
                          invalid={
                            validation.touched.question &&
                            validation.errors.question
                              ? true
                              : false
                          }
                        />
                        {validation.touched.question &&
                        validation.errors.question ? (
                          <FormFeedback type="invalid">
                            {validation.errors.question}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Type
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <Input
                          type="select"
                          name="question_type"
                          invalid={
                            validation.touched.question_type &&
                            validation.errors.question_type
                              ? true
                              : false
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.question_type}
                        >
                          <option value={"null"}>Select Type</option>
                          <option value="SHORT_ANSWER">SHORT ANSWER</option>
                          <option value="SINGLE_CORRECT">SINGLE CORRECT</option>
                          <option value="MULTI_CORRECT">MULTI CORRECT</option>
                        </Input>

                        {validation.touched.question_type &&
                        validation.errors.question_type ? (
                          <FormFeedback type="invalid">
                            {validation.errors.question_type}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center gap-2 justify-content-end">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            SEGMENT
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <Input
                          name="segmentId"
                          type="select"
                          invalid={
                            validation.touched.segmentId &&
                            validation.errors.segmentId
                              ? true
                              : false
                          }
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.segmentId}
                        >
                          <option value={"null"}>Select Segment</option>
                          {segmentList &&
                            segmentList.map(item => {
                              return (
                                <option key={item.id} value={item.id}>
                                  {item.name}
                                </option>
                              )
                            })}
                        </Input>
                        {validation.touched.segmentId &&
                        validation.errors.segmentId ? (
                          <FormFeedback>
                            {validation.errors.segmentId}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Status
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="9">
                        <div className="d-flex gap-3">
                          <div className="d-flex gap-1">
                            <input
                              type="radio"
                              name="isActive"
                              value="true"
                              checked={validation.values.isActive === "true"}
                              onClick={() =>
                                validation.setFieldValue("isActive", "true")
                              }
                            />
                            Active
                          </div>
                          <div className="d-flex gap-1">
                            <input
                              type="radio"
                              name="isActive"
                              value="false"
                              checked={validation.values.isActive === "false"}
                              onClick={() =>
                                validation.setFieldValue("isActive", "false")
                              }
                            />
                            Inactive
                          </div>
                        </div>
                        {validation.touched.isActive &&
                        validation.errors.isActive ? (
                          <div
                            style={{
                              color: "#f46a6a",
                              fontSize: "0.675rem",
                              marginTop: "0.25rem",
                            }}
                          >
                            {validation.errors.isActive}
                          </div>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            WEBHOOKIDENTIFIER
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <Input
                          name="webhookIdentifier"
                          value={validation.values.webhookIdentifier}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.webhookIdentifier &&
                            validation.errors.webhookIdentifier
                              ? true
                              : false
                          }
                          placeholder="Enter WebhookIdentifier..."
                        />
                        {validation.touched.webhookIdentifier &&
                        validation.errors.webhookIdentifier ? (
                          <FormFeedback type="invalid">
                            {validation.errors.webhookIdentifier}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-end">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase p-0">
                            Question short Text
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <Input
                          name="shortForm"
                          value={validation.values.shortForm}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.shortForm &&
                            validation.errors.shortForm
                              ? true
                              : false
                          }
                          placeholder="Enter Question Short Text..."
                        />
                        {validation.touched.shortForm &&
                        validation.errors.shortForm ? (
                          <FormFeedback type="invalid">
                            {validation.errors.shortForm}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Question description
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="9">
                        <Input
                          name="description"
                          type="textarea"
                          rows="5"
                          value={validation.values.description || ""}
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.description &&
                            validation.errors.description
                              ? true
                              : false
                          }
                          placeholder="Enter Question Description..."
                        />
                        {validation.touched.description &&
                        validation.errors.description ? (
                          <FormFeedback type="invalid">
                            {validation.errors.description}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Boiler Plate Text
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="9">
                        <ReactQuill
                          placeholder={`${"Write your answer here..."}`}
                          modules={{
                            toolbar: toolbarOptions,
                          }}
                          style={{ backgroundColor: "white" }}
                          theme="snow"
                          value={validation.values.boilerPlateText || ""}
                          onChange={value => {
                            validation.setFieldValue("boilerPlateText", value)
                          }}
                        />
                         {
                              validation.touched.boilerPlateText &&
                              validation.errors.boilerPlateText ? (
                                <div
                                style={{
                                  color: "#f46a6a",
                                  fontSize: "0.675rem",
                                  marginTop: "0.25rem",
                                }}
                              >
                                  {validation.errors.boilerPlateText}
                               </div>
                              ) : null
                           }
                      </Col>
                      <Col xs="12" sm="12" md="3">
                        <div className=" h-100 d-flex align-items-center justify-content-between">
                          <h4 className="mb-sm-0 font-size-16 text-uppercase">
                            Question Image
                          </h4>
                        </div>
                      </Col>
                      <Col xs="12" sm="12" md="9">
                        <Input
                          type="file"
                          name="image"
                          onChange={event => {
                            validation.setFieldValue(
                              "image",
                              event.target.files[0]
                            )
                          }}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.image && validation.errors.image
                              ? true
                              : false
                          }
                        />
                        {validation.touched.image && validation.errors.image ? (
                          <FormFeedback type="invalid">
                            {validation.errors.image}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xs="12" md="3"></Col>
                      <Col xs="12" md="9">
                        <a
                          href={questionAndAnswerDetails?.image_url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img-fluid rounded w-25"
                            src={questionAndAnswerDetails?.image_url}
                            alt="image"
                          />
                        </a>
                      </Col>
                      <Col xs="12">
                        <div className="text-end d-flex justify-content-end align-items-center gap-3">
                          <button
                            type="button"
                            onClick={() => navigate(`/q-n-a`)}
                            className="btn theme-btn-outline save-user mr-2"
                          >
                            Go To Question List
                          </button>
                          <button
                            type="submit"
                            className="btn theme-btn save-user"
                          >
                            Update
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Form>
          <Row className="pb-1">
            <Col xs={12}>
              <div className=" h-100 d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-16 text-uppercase">
                  Answer List
                </h4>
                {!adding && (
                  <span
                    className="text-primary d-flex align-items-center gap-1
                "
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setAdding(true)
                      setOpen([
                        ...open,
                        questionAndAnswerDetails?.answer?.length,
                      ])
                      setQuestionAndAnswerDetails({
                        ...questionAndAnswerDetails,
                        answer: [
                          ...questionAndAnswerDetails?.answer,
                          {
                            answer: "",
                            overview: null,
                            growthScore: null,
                            group: "",
                            isActive: "",
                            scoreDescription: null,
                            suggestedStrategy: "",
                            keyAction: "",
                            webhookIdentifier: "",
                          },
                        ],
                      })
                      setTimeout(() => {
                        document
                          .getElementById(
                            questionAndAnswerDetails?.answer?.length
                          )
                          ?.scrollIntoView({
                            block: "nearest",
                            inline: "nearest",
                            behavior: "smooth",
                          })
                      }, 200)
                    }}
                  >
                    <span className="bx bx-plus font-size-20"></span>
                    Add Answer
                  </span>
                )}
              </div>
            </Col>
          </Row>
          {questionAndAnswerDetails?.answer?.length > 0 ? (
            questionAndAnswerDetails?.answer?.map((item, index) => {
              return (
                <MyAccordian
                  item={item}
                  key={index}
                  index={index}
                  open={open}
                  setOpen={setOpen}
                  questionId={questionAndAnswerDetails?.id}
                  questionDetails={questionAndAnswerDetails}
                  setQuestionAndAnswerDetails={setQuestionAndAnswerDetails}
                  adding={adding}
                  setAdding={setAdding}
                />
              )
            })
          ) : (
            <Card>
              <CardBody>
                <h4 className="text-center">No Answer Found</h4>
              </CardBody>
            </Card>
          )}
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  )
}

export default EditQAndA

const MyAccordian = ({
  item,
  index,
  open,
  setOpen,
  questionId,
  setQuestionAndAnswerDetails,
  adding,
  setAdding,
  questionDetails,
}) => {
  const toggle = id => {
    if (open.includes(id)) {
      setOpen(open.filter(i => i !== id))
    } else {
      setOpen([...open, id])
    }
  }

  return (
    <Accordion
      open={open}
      toggle={toggle}
      className="accordion-flush"
      id={index}
    >
      <CardBody>
        <AccordionItem className="my-3">
          <AccordionHeader targetId={index}>
            <span
              style={{
                position: "absolute",
                left: "0rem",
                padding: "0.5rem .8rem",
                borderTopRightRadius: "0.5rem",
                borderBottomRightRadius: "0.5rem",
                backgroundColor: "#e4661d",
                color: "#fff",
              }}
            >
              A{index + 1}
            </span>
            <p
              style={{
                border: open.includes(index) ? "1px solid #e5e5e5" : "none",
                margin: "0",
                padding: "1rem",
                marginLeft: "2rem",
                marginRight: "2rem",
              }}
            >
              {item.isAdding ? "Add New Answer" : item?.answer}
            </p>
          </AccordionHeader>
          <AccordionBody accordionId={index} key={`inner${index}`}>
            <AnswerForm
              item={item}
              index={index}
              questionId={questionId}
              setQuestionAndAnswerDetails={setQuestionAndAnswerDetails}
              adding={adding}
              setAdding={setAdding}
              questionDetails={questionDetails}
            />
          </AccordionBody>
        </AccordionItem>
      </CardBody>
    </Accordion>
  )
}

const AnswerForm = ({
  index,
  item,
  questionId,
  setQuestionAndAnswerDetails,
  adding,
  setAdding,
  questionDetails,
}) => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      answer: item.answer,
      overview: item.overview,
      growthScore: item.growthScore,
      group: item.group,
      isActive: item.isActive === true ? "true" : "false",
      scoreDescription: item.scoreDescription,
      suggestedStrategy: item.suggestedStrategy,
      keyAction: item.keyAction,
      webhookIdentifier: item.webhookIdentifier,
      strength: item.strength,
      threats: item.threats,
      weakness: item.weakness,
      opportunities: item.opportunities,
    },
    validationSchema: Yup.object({
      answer: Yup.string().required("Please Enter Answer"),
      growthScore: Yup.string().nullable().test({
        name:'growthScore',
        test: (value,context) => {
        if(questionDetails.question_type ==='MULTI_CORRECT'){
          return true;
        }else{
            if(!Boolean(value) || value === "<p><br></p>"){
              return context.createError({
                message: "Please Enter Growth Score",
              })
            }
            return true;
          }
        }
      }),
      webhookIdentifier: Yup.string().required(
        "Please Enter WebhookIdentifier"
      ),
      isActive: Yup.string().required("Please Select Status"),
      group: Yup.string().nullable(),
      scoreDescription: Yup.string().nullable().test({
        name:'scoreDescription',
        test: (value,context) => {
        if(questionDetails.question_type ==='MULTI_CORRECT'){
          return true;
        }else{
            if(!Boolean(value) || value === "<p><br></p>"){
              return context.createError({
                message: "Please Enter Score Description",
              })
            }
            return true;
          }
        }
      }),
      suggestedStrategy: Yup.string().required(
        "Please Enter Suggested Strategy"
      ),
      overview: Yup.string().nullable().test({
        name:'overview',
        test: (value,context) => {
        if(questionDetails.question_type ==='MULTI_CORRECT'){
          return true;
        }else{
            if(!Boolean(value) || value === "<p><br></p>"){
              return context.createError({
                message: "Please Enter Overview",
              })
            }
            return true;
          }
        }
      }),
      keyAction: Yup.string().nullable(),
    }),
    onSubmit: async values => {
      if (item.id) {
        try {
          await API_SERVICE.updateAnswer(item.id, {
            ...values,
            isActive: values.isActive === "true",
            questionId: questionId,
          })
          notification("success", "Answer Updated Successfully")
        } catch (error) {
          notification("error", API_SERVICE.handleErrors(error))
        }
      } else {
        try {
          const data = await API_SERVICE.addAnswer({
            ...values,
            isActive: values.isActive === "true",
            questionId: questionId,
          })
          notification("success", "Answer Added Successfully")
          setQuestionAndAnswerDetails(prev => {
            const answer = prev.answer
            answer[answer.length - 1] = {
              ...values,
              isActive: values.isActive === "true",
              questionId: questionId,
              id : data.data.data.id
            }
            return {
              ...prev,
              answer,
            }
          })

          setAdding(false)
        } catch (error) {
          notification("error", API_SERVICE.handleErrors(error))
        }
      }
    },
  })

  const deleteAnswer = async () => {
    try {
      await API_SERVICE.deleteAnswer(item.id)
      setQuestionAndAnswerDetails(prev => {
        return {
          ...prev,
          answer: prev.answer.filter(i => i.id !== item.id),
        }
      })
      notification("success", "Answer Deleted Successfully")
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }

  return (
    <Form
      key={index}
      className="form-horizontal"
      onSubmit={e => {
        e.preventDefault()
        validation.handleSubmit()
        return false
      }}
    >
      <Row className="mt-3">
        <Col xs="12">
          <Card>
            <CardBody
              style={{
                minHeight: "calc(100vh - 230px)",
              }}
            >
              <Row
                style={{
                  rowGap: "1.5rem",
                }}
              >
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Question Text
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="answer"
                    placeholder="Enter answer"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.answer || ""}
                    invalid={
                      validation.touched.answer && validation.errors.answer
                        ? true
                        : false
                    }
                  />
                  {validation.touched.answer && validation.errors.answer ? (
                    <FormFeedback type="invalid">
                      {validation.errors.answer}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      GROWTH SCORE
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="3">
                  <Input
                    name="growthScore"
                    type="number"
                    placeholder="Enter Growth Score"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.growthScore || ""}
                    invalid={
                      validation.touched.growthScore &&
                      validation.errors.growthScore
                        ? true
                        : false
                    }
                  />
                  {validation.touched.growthScore &&
                  validation.errors.growthScore ? (
                    <FormFeedback type="invalid">
                      {validation.errors.growthScore}
                    </FormFeedback>
                  ) : null}
                </Col>

                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      WEBHOOKIDENTIFIER
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="3">
                  <Input
                    name="webhookIdentifier"
                    value={validation.values.webhookIdentifier}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.webhookIdentifier &&
                      validation.errors.webhookIdentifier
                        ? true
                        : false
                    }
                    placeholder="Enter WebhookIdentifier..."
                  />
                  {validation.touched.webhookIdentifier &&
                  validation.errors.webhookIdentifier ? (
                    <FormFeedback type="invalid">
                      {validation.errors.webhookIdentifier}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Status
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <div className="d-flex gap-3">
                    <div className="d-flex gap-1">
                      <input
                        type="radio"
                        name="isActive"
                        value="true"
                        checked={validation.values.isActive === "true"}
                        onClick={() =>
                          validation.setFieldValue("isActive", "true")
                        }
                      />
                      Active
                    </div>
                    <div className="d-flex gap-1">
                      <input
                        type="radio"
                        name="isActive"
                        value="false"
                        checked={validation.values.isActive === "false"}
                        onClick={() =>
                          validation.setFieldValue("isActive", "false")
                        }
                      />
                      Inactive
                    </div>
                  </div>
                  {validation.touched.isActive && validation.errors.isActive ? (
                    <div
                      style={{
                        color: "#f46a6a",
                        fontSize: "0.675rem",
                        marginTop: "0.25rem",
                      }}
                    >
                      {validation.errors.isActive}
                    </div>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase p-0">
                      Group
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="group"
                    value={validation.values.group}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.group && validation.errors.group
                        ? true
                        : false
                    }
                    placeholder="Enter Group..."
                  />
                  {validation.touched.group && validation.errors.group ? (
                    <FormFeedback type="invalid">
                      {validation.errors.group}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      score description
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="scoreDescription"
                    value={validation.values.scoreDescription}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.scoreDescription &&
                      validation.errors.scoreDescription
                        ? true
                        : false
                    }
                    placeholder="Enter score description..."
                  />
                  {validation.touched.scoreDescription &&
                  validation.errors.scoreDescription ? (
                    <FormFeedback type="invalid">
                      {validation.errors.scoreDescription}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Suggested Strategy
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="suggestedStrategy"
                    value={validation.values.suggestedStrategy}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.suggestedStrategy &&
                      validation.errors.suggestedStrategy
                        ? true
                        : false
                    }
                    placeholder="Enter suggested strategy..."
                  />
                  {validation.touched.suggestedStrategy &&
                  validation.errors.suggestedStrategy ? (
                    <FormFeedback type="invalid">
                      {validation.errors.suggestedStrategy}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Overview
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="overview"
                    type="textarea"
                    rows="5"
                    value={validation.values.overview}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.overview && validation.errors.overview
                        ? true
                        : false
                    }
                    placeholder="Enter overview..."
                  />
                  {validation.touched.overview && validation.errors.overview ? (
                    <FormFeedback type="invalid">
                      {validation.errors.overview}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Key Note
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="keyAction"
                    value={validation.values.keyAction}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.keyAction &&
                      validation.errors.keyAction
                        ? true
                        : false
                    }
                    placeholder="Enter key note..."
                  />
                  {validation.touched.keyAction &&
                  validation.errors.keyAction ? (
                    <FormFeedback type="invalid">
                      {validation.errors.keyAction}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Strength
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="strength"
                    value={validation.values.strength}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.strength && validation.errors.strength
                        ? true
                        : false
                    }
                    placeholder="Enter strength..."
                  />
                  {validation.touched.strength && validation.errors.strength ? (
                    <FormFeedback type="invalid">
                      {validation.errors.strength}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Threats
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="threats"
                    value={validation.values.threats}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.threats && validation.errors.threats
                        ? true
                        : false
                    }
                    placeholder="Enter threats..."
                  />
                  {validation.touched.threats && validation.errors.threats ? (
                    <FormFeedback type="invalid">
                      {validation.errors.threats}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Weakness
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="weakness"
                    value={validation.values.weakness}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.weakness && validation.errors.weakness
                        ? true
                        : false
                    }
                    placeholder="Enter weakness..."
                  />
                  {validation.touched.weakness && validation.errors.weakness ? (
                    <FormFeedback type="invalid">
                      {validation.errors.weakness}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12" sm="12" md="3">
                  <div className=" h-100 d-flex align-items-center justify-content-between">
                    <h4 className="mb-sm-0 font-size-16 text-uppercase">
                      Opportunities
                    </h4>
                  </div>
                </Col>
                <Col xs="12" sm="12" md="9">
                  <Input
                    name="opportunities"
                    value={validation.values.opportunities}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={
                      validation.touched.opportunities &&
                      validation.errors.opportunities
                        ? true
                        : false
                    }
                    placeholder="Enter opportunities..."
                  />
                  {validation.touched.opportunities &&
                  validation.errors.opportunities ? (
                    <FormFeedback type="invalid">
                      {validation.errors.opportunities}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col xs="12">
                  <div className="text-end d-flex justify-content-end align-items-center gap-3">
                    <button
                      type="button"
                      className="btn theme-btn-outline save-user mr-2"
                      onClick={() => {
                        if (adding) {
                          setQuestionAndAnswerDetails(prev => {
                            return {
                              ...prev,
                              answer: prev.answer.filter(i => i.id !== item.id),
                            }
                          })
                          setAdding(false)
                        } else {
                          deleteAnswer()
                        }
                      }}
                    >
                      Delete
                    </button>
                    <button type="submit" className="btn theme-btn save-user">
                      {item.id ? "Update" : "Add"}
                    </button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Form>
  )
}
